import { endpoint } from './endpoint.js';
import { ListAuditLogsQuerySchema, AuditLogListResponseSchema } from '../schemas/audit-log.js';

export const auditLogs = {
  /** GET /admin/audit-logs — paginated audit log list (admin only) */
  list: endpoint('GET', '/admin/audit-logs', ListAuditLogsQuerySchema, AuditLogListResponseSchema),
};
